export const locationConstants = {
    REQUEST_CITIES: "REQUEST_CITIES",
    REQUEST_DISTRICTS: "REQUEST_DISTRICTS"
};



// WEBPACK FOOTER //
// ./src/_constants/location.constants.js